'use client'
import { Excanary, Media } from '@/payload-types'
import ImageComponent from '../media/imageComponent'
import { useRouter } from 'next/navigation'
import Image from 'next/image'
import { IExCanaryNavData } from './ex-canary-helpers'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

const renderNavButton = (router: AppRouterInstance, navData: IExCanaryNavData) => {
  return (
    <div className="flex pt-6 gap-4 sm:justify-start justify-center">
      <button
        onClick={() => router.push('/ex-canary/' + navData.prevSlug)}
        disabled={!navData.prevSlug}
        className={
          'bg-black !text-white sm:pr-4 pl-2 pr-2 py-2 rounded-md hover:bg-gray-600  flex items-center' +
          (navData.prevSlug ? '' : ' !bg-gray-300 pointer-events-none')
        }
      >
        <Image
          className="sm:w-[24px] sm:h-[24px] w-[35px] h-[35px]"
          src={`/images/favicons/chevron-left.svg`}
          alt="chevron-left"
          width={24}
          height={24}
        />
        <span className="sm:block hidden">Prev</span>
      </button>

      <button
        onClick={() => router.push('/ex-canary')}
        className="bg-black !text-white px-4 py-2 rounded-md hover:bg-gray-600"
      >
        Ex-Canary Lobby Page
      </button>

      <button
        onClick={() => router.push('/ex-canary/' + navData.nextSlug)}
        className={
          'bg-black !text-white sm:pl-4 pl-2 pr-2 py-2 rounded-md hover:bg-gray-600 flex items-center' +
          (navData.nextSlug ? '' : ' !bg-gray-300 pointer-events-none')
        }
      >
        <span className="sm:block hidden">Next</span>
        <Image
          className="sm:w-[24px] sm:h-[24px] w-[35px] h-[35px]"
          src={`/images/favicons/chevron-right.svg`}
          alt="chevron-right"
          width={24}
          height={24}
        />
      </button>
    </div>
  )
}

export const ExCanaryIndividualPage = ({
  data,
  navData,
}: {
  data: Excanary
  navData: IExCanaryNavData
}) => {
  const router = useRouter()

  return (
    <div className="p-4 PageInternalContainer min-h-[100vh] flex flex-col justify-between">
      <div>
        <div className="min-[768px]:block hidden">{renderNavButton(router, navData)}</div>

        <div className="flex flex-col gap-2 sm:py-10 pb-4">
          <Image
            alt="red-quote-left"
            src={'/images/favicons/red-quote-left.svg'}
            width={35}
            height={35}
          />
          <p className="text-lg font-bold text-gray-900 italic pt-3">{data.excanaryQuote}</p>
        </div>

        <p className="flex flex-col gap-2">
          {data.media?.map((media: string | Media, index: number) => (
            <ImageComponent
              key={index}
              src={`${process.env.NEXT_PUBLIC_PAYLOAD_URL ?? ''}${(media as Media).url || ''}`}
              alt={(media as Media).title || ''}
              width={100}
              height={100}
            />
          ))}
        </p>
      </div>
      <div className="min-[768px]:hidden">{renderNavButton(router, navData)}</div>
    </div>
  )
}
